import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetSellerLowStockProducts } from '~/api';
import { ProductStockColumn } from './shared/ProductStockColumn';

function HealthBadge({ health }: { health: string | null | undefined }) {
  const { t } = useTranslation('dashboard');

  if (!health) return null;

  if (health === 'CRITICAL') {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium text-error-700 bg-error-100">
        {t('dashboard.seller_low_stock.health_critical')}
      </span>
    );
  }

  if (health === 'LOW') {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium text-warning-700 bg-warning-100">
        {t('dashboard.seller_low_stock.health_low')}
      </span>
    );
  }

  if (health === 'HEALTHY') {
    return (
      <span className="px-2 py-1 rounded-full text-xs font-medium bg-success-100 text-success-700">
        {t('dashboard.seller_low_stock.health_monitor')}
      </span>
    );
  }

  return null;
}

export function LowStockProductsColumn() {
  const { t } = useTranslation('dashboard');
  const { data, isLoading, isError } = useGetSellerLowStockProducts();

  const rows = useMemo(
    () =>
      (data?.sellerLowStockProducts ?? []).map((spc) => {
        return {
          id: spc.id,
          productName:
            spc.platformProductLength.platformProduct.name +
            (spc.platformProductLength.lengthDisplayValue
              ? ` ${spc.platformProductLength.lengthDisplayValue}`
              : ''),
          label: <HealthBadge health={spc.health} />,
          metaItems: [],
          action: null,
        };
      }),
    [data]
  );

  return (
    <ProductStockColumn
      title={t('dashboard.seller_low_stock.title')}
      subtitle={t('dashboard.seller_low_stock.subtitle')}
      footerLink="/my-products"
      footerLabel={t('dashboard.seller_low_stock.footer')}
      rows={rows}
      isLoading={isLoading}
      isError={isError}
      emptyText={t('dashboard.seller_low_stock.empty')}
      errorText={t('dashboard.seller_low_stock.error')}
    />
  );
}
